module.exports = __webpack_public_path__ + "static/scale-model-of-buffalo-cobblestone-district-in-buffalo-new-york-5516825a7389ce590f10640002f05b73.png";